import { ReactComponent as DefaultPrescriptionImage } from '@assets/icons/prescription_default.svg';
import CanvasImage from '@components/CanvasImage';
import HorizontalScrollArrow from '@components/HorizontalScrollArrow';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { PRESCRIPTION_IMAGE_SLIDE } from '@pages/Prescription/focusKey';
import { FC, useCallback, useEffect, useState } from 'react';

import * as styles from './styles';

interface ImageSlideProps {
  urls: string[];
}

const ImageSlide: FC<ImageSlideProps> = ({ urls }) => {
  const { ref, focusKey } = useFocusable({ focusKey: PRESCRIPTION_IMAGE_SLIDE });
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [urls]);

  const changeIndex = useCallback(
    (newIndex: number) => {
      if (index !== newIndex) {
        setIndex(newIndex);
      }
    },
    [index]
  );
  const selectPrevious = useCallback(() => {
    changeIndex(Math.max(0, index - 1));
  }, [changeIndex, index]);
  const selectNext = useCallback(() => {
    changeIndex(Math.min(urls.length - 1, index + 1));
  }, [changeIndex, index, urls.length]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.imageSlideWrapper}>
        <HorizontalScrollArrow isLeft={true} onEnterPress={selectPrevious} />
        <div css={styles.imageWrapper}>
          <CanvasImage
            url={urls[index]}
            defaultImage={<DefaultPrescriptionImage css={styles.defaultImage} />}
          />
        </div>
        <HorizontalScrollArrow isLeft={false} onEnterPress={selectNext} />
      </div>
    </FocusContext.Provider>
  );
};

export default ImageSlide;
